// @flow

import React from "react";
import { Container, Input, Label } from "./styles";

type Props = {
  placeholder?: string,
  onChange: Function,
  value: string | number,
  label?: string,
  labelWeight?: "normal" | "bold",
  containerStyle?: Object,
};

const TextInput = ({
  value,
  placeholder = "",
  onChange,
  label = "",
  labelWeight = "normal",
  containerStyle = {},
  ...restProps
}: Props) => {
  return (
    <Container style={containerStyle}>
      <Label weight={labelWeight}>{label}</Label>
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...restProps}
      />
    </Container>
  );
};

export default TextInput;
